import { cn } from '../../lib/cn';
import type { ProductionOpsRow } from '../../enterprisedevops/framework';

type Props = { items?: ProductionOpsRow[] };

export function ProductionOperationsPanel({ items = [] }: Props) {
  return (
    <div className="space-y-2">
      {items.map((i) => (
        <div key={i.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{i.name}</p>
              <p className="text-xs text-slate-500">{i.category}</p>
            </div>
            <span className={cn(
              'shrink-0 rounded-full px-2 py-0.5 text-xs font-medium',
              i.status === 'passed' || i.status === 'current' || i.status === 'active' || i.status === 'daily'
                ? 'bg-success-50 text-success-700 dark:bg-success-950 dark:text-success-300'
                : 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
            )}>
              {i.status} · {i.score}%
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}
